<div class="container-fluid bg-grey">
  <h2 class="rounded text-center mt-4">Individual Assessment</h2>
<!--<prettyjson [obj]="data"></prettyjson>-->
  <section>
    <form [formGroup]="form">
      <mat-card class="rounded">
        <div class="row">
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Session Type']">info</mat-icon>
            <mat-label>Session Type</mat-label>
            <mat-select required formControlName="type">
              <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>
            </mat-select>
          </mat-form-field>

          <!--------------------------------------------- Select Centre --------------------------------------------->
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Centre Name']">info</mat-icon>
            <mat-label>Select Centre</mat-label>
            <input matInput aria-label="Default select example" formControlName="centreName"
            />
          </mat-form-field>
          <!---------------------------------------------Select Child Name --------------------------------------------->
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Child Name']">info</mat-icon>
            <mat-label>Child Name</mat-label>
            <input matInput aria-label="Default select example" formControlName="childName"
            />
          </mat-form-field>

          <!--------------------------------------------- Parents Name --------------------------------------------->
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Parents Name']">info</mat-icon>
            <mat-label>Parents Name</mat-label>

            <input matInput placeholder="Parents Name" formControlName="parentsName">
          </mat-form-field>


          <!--------------------------------------------- HOMETOWN --------------------------------------------->

          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Hometown']">info</mat-icon>
            <mat-label>Hometown</mat-label>
            <input matInput placeholder="Home town" formControlName="city" readonly>
          </mat-form-field>
          <!--------------------------------------------- Date of Admission --------------------------------------------->
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-label>Date of Admission</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dateOfAdmission" readonly>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <!--------------------------------------------- Person conducting conducting test --------------------------------------------->
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-label>Person Conducting this test</mat-label>
            <mat-select formControlName="personConductingTest">
              <mat-option *ngFor="let e of (emp$|async)" [value]="e.userName">{{e.userName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <!--------------------------------------------- Designation --------------------------------------------->
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-label>Designation of this person</mat-label>
            <input matInput formControlName="designation">
          </mat-form-field>
          <!--------------------------------------------- Date of baseline assessment Test --------------------------------------------->
          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-label>Date of baseline test carried out</mat-label>
            <input matInput [matDatepicker]="apicker" formControlName="dateOfAssessment">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="apicker"></mat-datepicker-toggle>
            <mat-datepicker #apicker></mat-datepicker>
          </mat-form-field>

        </div>
      </mat-card>
      <mat-card class="mt-2">
        <div formArrayName="assessment">
          <h2 class="rounded rounded-2 text-center"> Assessment Questions</h2>
          <ng-container *ngFor=" let f of assessments.controls;let i=index">
            <div [formArrayName]="i">
              <h3>{{questionSet[i]}}</h3>
              <div>
                <mat-radio-group color="primary" aria-labelledby="example-radio-group-label"
                                 class="example-radio-group" formControlName="ans">
                  <mat-radio-button class="example-radio-button" *ngFor="let ans of answers"
                                    [value]="ans">
                    {{ans}}
                  </mat-radio-button>&nbsp;&nbsp;
                </mat-radio-group>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="d-flex justify-content-center">
          <button mat-raised-button color="primary" type="submit" (click)="Submit()">Submit</button>
        </div>

      </mat-card>
      <!--------------------------------------------- row end --------------------------------------------->


    </form>
  </section>

</div>
